import { Panel, PanelHeader } from "../../../element/Panel";
import { Notice } from "../../../element/Notice";
import { ServerGroupSelector } from "../../../common/ServerGroupSelector";

import type { ServerGroupSelectorProps } from "../../../common/ServerGroupSelector";

export function ServerServerGroupSelector({ editor, }: ServerGroupSelectorProps) {
    const { value, } = editor;

    return (
        <Panel>
            <PanelHeader
                title='Server Groups'
                description='To which Server Groups should this Cloud Server belong?'
            />
            <ServerGroupSelector editor={editor} selectSingle={false}>
                {Array.isArray(value) && value.length === 0
                    ? <Notice type='warning' icon='warning-fill'>
                        <b>Note</b> – Server Groups are used to allow network access to Cloud Servers via firewall rules, so
                        a Cloud Server won't have any network access until it is added to a Server Group
                    </Notice>
                    : null}
            </ServerGroupSelector>
        </Panel>
    );
}